import { defineStore } from 'pinia';

export const useQueryStore = defineStore('query', {
  state   : () => ({
    bookingQuery                  : { pagination : { page : 1, perPage : 10 }, filters : {} },
    classeurQuery                 : { pagination : { page : 1, perPage : 10 }, filters : {} },
    clerkQuery                    : { pagination : { page : 1, perPage : 10 }, filters : {} },
    folderQuery                   : { pagination : { page : 1, perPage : 10 }, filters : {} },
    incomingInvoicesQuery         : { pagination : { page : 1, perPage : 10 }, filters : {} },
    issuedInvoicesQuery           : { pagination : { page : 1, perPage : 10 }, filters : {} },
    notaryQuery                   : { pagination : { page : 1, perPage : 10 }, filters : {} },
    offerQuery                    : { pagination : { page : 1, perPage : 10 }, filters : {} },
    proformaQuery                 : { pagination : { page : 1, perPage : 10 }, filters : {} },
    taskQuery                     : { pagination : { page : 1, perPage : 10 }, filters : {} },
    thirdPartyInvoicesToBeCreated : { pagination : { page : 1, perPage : 10 }, filters : {} },
    userRelationQuery             : { pagination : { page : 1, perPage : 10 }, filters : {} }
  }),
  actions : {
    resetAllQueries() {

      this.resetBookingQuery();
      this.resetClasseurQuery();
      this.resetClerkQuery();
      this.resetFolderQuery();
      this.resetIncomingInvoicesQuery();
      this.resetIssuedInvoicesQuery();
      this.resetNotaryQuery();
      this.resetOfferQuery();
      this.resetProformaQuery();
      this.resetTaskQuery();
      this.resetThirdPartyInvoicesToBeCreated();
      this.resetUserRelationQuery();
    },
    setQuery(model, query) {

      if (query.filters) {

        this[model] = {
          pagination : { ...this[model].pagination, page : 1 },
          filters    : query.filters
        };
        return;
      }

      this[model] = { ...this[model], ...query };
    },
    resetBookingQuery() {

      this.bookingQuery = { pagination : { page : 1, perPage : 10 }, filters : {} };
    },
    resetClasseurQuery() {

      this.classeurQuery = { pagination : { page : 1, perPage : 10 }, filters : {} };
    },
    resetClerkQuery() {

      this.clerkQuery = { pagination : { page : 1, perPage : 10 }, filters : {} };
    },
    resetFolderQuery() {

      this.folderQuery = { pagination : { page : 1, perPage : 10 }, filters : {} };
    },
    resetIncomingInvoicesQuery() {

      this.incomingInvoicesQuery = { pagination : { page : 1, perPage : 10 }, filters : {} };
    },
    resetIssuedInvoicesQuery() {

      this.issuedInvoicesQuery = { pagination : { page : 1, perPage : 10 }, filters : {} };
    },
    resetNotaryQuery() {

      this.notaryQuery = { pagination : { page : 1, perPage : 10 }, filters : {} };
    },
    resetOfferQuery() {

      this.offerQuery = { pagination : { page : 1, perPage : 10 }, filters : {} };
    },
    resetProformaQuery() {

      this.proformaQuery = { pagination : { page : 1, perPage : 10 }, filters : {} };
    },
    resetTaskQuery() {

      this.taskQuery = { pagination : { page : 1, perPage : 10 }, filters : {} };
    },
    resetThirdPartyInvoicesToBeCreated() {

      this.thirdPartyInvoicesToBeCreated = { pagination : { page : 1, perPage : 10 }, filters : {} };
    },
    resetUserRelationQuery() {

      this.userRelationQuery = { pagination : { page : 1, perPage : 10 }, filters : {} };
    }
  }
});
